import { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { images, testimonials, TID } from "@/data";

const Testimonials = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: "start",
    dragFree: false,
  });
  const [selected, setSelected] = useState(0);
  const [snaps, setSnaps] = useState([]);

  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi]);
  const scrollTo = useCallback((i) => emblaApi && emblaApi.scrollTo(i), [emblaApi]);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelected(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    setSnaps(emblaApi.scrollSnapList());
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
    onSelect();
  }, [emblaApi, onSelect]);

  const [paused, setPaused] = useState(false);
  useEffect(() => {
    if (!emblaApi || paused) return;
    const id = setInterval(() => {
      if (document.hidden) return;
      emblaApi.scrollNext();
    }, 4000);
    return () => clearInterval(id);
  }, [emblaApi, paused]);

  return (
    <section className="tst section">
      <div className="container">
        <div className="tst__head">
          <div className="tst__head-left">
            <h2 className="tst__title">Trusted by Travel Agents, Corporates &amp; Thousands of Happy Travelers</h2>
          </div>
          <div className="tst__arrows">
            <button className="tst__arrow" aria-label="Previous testimonial" onClick={scrollPrev} data-testid={TID.testimonialPrev}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </button>
            <button className="tst__arrow" aria-label="Next testimonial" onClick={scrollNext} data-testid={TID.testimonialNext}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </button>
          </div>
        </div>

        <div className="tst__viewport" ref={emblaRef} onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
          <div className="tst__track">
            {testimonials.map((t, i) => (
              <figure className={`tst-card ${i % 2 === 0 ? "tst-card--solid" : ""}`} key={t.name + i}>
                <img className="tst-card__quote" src={images.testimonialQuote} alt="" aria-hidden="true" />
                <blockquote className="tst-card__text">{t.quote}</blockquote>
                <figcaption className="tst-card__person">
                  <img className="tst-card__avatar" src={t.avatar} alt={t.name} loading="lazy" />
                  <span className="tst-card__meta">
                    <span className="tst-card__name">{t.name}</span>
                    {t.role && <span className="tst-card__role">{t.role}</span>}
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>

        <div className="tst__dots">
          {snaps.map((_, i) => (
            <button
              key={i}
              className={`tst__dot ${i === selected ? "tst__dot--active" : ""}`}
              aria-label={`Go to testimonial ${i + 1}`}
              onClick={() => scrollTo(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
